import { createSlice } from "@reduxjs/toolkit";

const selectedCustomer = createSlice({
  name: "SelectedCustomer",
  initialState: {
    full_name: "",
    number: "",
    email: "",
  },
  reducers: {
    setSelectedCustomer: (state, action) => {
      return { ...state, ...action.payload };
    },

    resetSelectedCustomer: (state) => {
      return state = {
        full_name: "",
        number: "",
        email: "",
        id: null,
      };
    },
  },
});

export const { setSelectedCustomer, setAddressData, resetSelectedCustomer } = selectedCustomer.actions;

export default selectedCustomer.reducer;
